import { useEffect, useState } from 'react'
import { Button, Col, Image, Row } from 'react-bootstrap'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import {
  createSearchParams,
  useNavigate,
  useOutletContext
} from 'react-router-dom'
import { PAGE_SETTING_NOTI_ADD } from '../../../router/routes'
import { getRightOrgAPI } from '../../../services/right-org'
import { BODYORGRIGHT } from '../../../Constants'
import { Controller, useForm } from 'react-hook-form'
import { HiOutlinePlus } from 'react-icons/hi'
import AutocompleteCustomA from '../../../components/custom/autocompletecustom'
import GenericTable from '../../../components/table'
import { TbListSearch } from 'react-icons/tb'
import { Pagination } from 'antd'
import { getAttendanceNotiAPI } from '../../../services/setting/attendance-noti'
import InputSearch from '../../../components/custom/InputSearch'
import { useDispatch, useSelector } from 'react-redux'
import { updateRole } from '../../../actions/role-org.action'
import { useTranslation } from 'react-i18next'
import imgUser from '../../../images/user.png'
import RowPerPageCustom from '../../../components/custom/RowPerPageCustom'

function NotiCheckInPege() {
  const {
    control,
    setValue,
    formState: {}
  } = useForm()
  const { t } = useTranslation()
  const { orgRole, setOrgSelete } = useOutletContext()
  const roleId = useSelector((state) => state.roleReducer.role)
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [search, setSearch] = useState()
  const [totalRows, setTotalRows] = useState(0)
  const [details, setDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!roleId) return

    const timer = setTimeout(() => {
      getIndexNoti({
        page, // ✅ ใช้ page จริง
        size: limit,
        orgId: roleId,
        search: search || ''
      })
    }, 400)

    return () => clearTimeout(timer)
  }, [roleId, search, page, limit])

  useEffect(() => {
    if (roleId && orgRole?.length) {
      const org = orgRole.find((item) => String(item.org_id) === String(roleId))

      if (org) {
        // set ให้ react-hook-form
        setValue('selectedOrg', {
          label: org.org,
          value: org.org_id
        })

        // set ให้ outlet context (ถ้าจำเป็น)
        setOrgSelete?.(org)
      }
    }
  }, [roleId, orgRole, setValue, setOrgSelete])

  const handleChangeOrg = (option) => {
    if (!option) return
    const orgId = option.value
    dispatch(updateRole(orgId))
    const org = orgRole.find((item) => String(item.org_id) === String(orgId))
    setOrgSelete?.(org)
    // ✅ reset ทุกอย่างให้ถูก
    setPage(1)
    setSearch('')
    getIndexNoti({
      page: 1,
      size: limit,
      orgId,
      search: ''
    })
  }

  useEffect(() => {
    let d = JSON.parse(localStorage.getItem(BODYORGRIGHT)) || {}
    const body = {
      ...d,
      page: d?.page ?? 1
    }
    getRightOrg(body)
  }, [])

  const getRightOrg = async (body) => {
    setPage(body.page)
    setIsLoading(true)
    localStorage.setItem(BODYORGRIGHT, JSON.stringify(body))
    const res = await getRightOrgAPI(body)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      // setDetails(res.result);
      // setTotalRows(res.totalRows)
    } else {
      // setDetails([]);
      // setTotalRows(0)
    }
    setIsLoading(false)
  }
  const getIndexNoti = async (body) => {
    setIsLoading(true)
    const res = await getAttendanceNotiAPI(body)
    setIsLoading(false)

    if (!res) return
    if (res.status) {
      setDetails(res.result)
      setTotalRows(res.totalRows)
    } else {
      setDetails([])
      setTotalRows(0)
    }
  }

  const navigate = useNavigate()

  const handleEditLocation = (d) => {
    navigate({
      pathname: PAGE_SETTING_NOTI_ADD,
      search: `?${createSearchParams({
        id: d ?? ''
      })}`
    })
  }
  const handleAdd = () => {
    navigate({
      pathname: PAGE_SETTING_NOTI_ADD
    })
  }
  const clearSearch = () => {
    setValue('search', '')
    setSearch('')
    setPage(1)
    getIndexNoti({
      page: 1,
      size: limit,
      orgId: roleId,
      search: ''
    })
  }

  const twoLineClampStyle = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  }

  const columns = [
    {
      header: t('hrms_notification_full_name_header'),
      minWidth: '310px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_notification_license-plate-number_header'),
      className: 'text-center',
      minWidth: '150px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: t('hrms_notification_remark_header'),
      className: 'text-center',
      minWidth: '150px',
      headerStyle: {
        textAlign: 'left',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: (
        <div className="text-center">
          <div style={{ fontWeight: 500 }}>
            {t('hrms_notification_lark_groups_header')}
          </div>
          <div
            style={{
              fontSize: 12,
              // color: "var(--color-on-base-content-low)",
              marginTop: 2
            }}
          >
            {t('hrms_notification_active_total_lark_groups_header')}
          </div>
        </div>
      ),
      className: 'text-center',
      minWidth: '120px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },
    {
      header: (
        <div className="text-center">
          <div style={{ fontWeight: 500 }}>
            {t('hrms_notification_line_groups_header')}
          </div>
          <div
            style={{
              fontSize: 12,
              // color: "var(--color-on-base-content-low)",
              marginTop: 2
            }}
          >
            {t('hrms_notification_active_total_line_groups_header')}
          </div>
        </div>
      ),
      className: 'text-center',
      minWidth: '120px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    },

    {
      header: t('hrms_notification_action_header'),
      className: 'text-center',
      minWidth: '120px',
      headerStyle: {
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
      }
    }
  ]

  const renderLocationRow = (details, borderStyle, onEdit) => {
    const nameCellStyle = (minWidth) => ({
      ...borderStyle,
      minWidth,
      textAlign: 'left',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap'
    })

    const centerCellStyle = (minWidth) => ({
      ...borderStyle,
      minWidth,
      textAlign: 'center',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap'
    })

    return (
      <>
        <td style={nameCellStyle('310px')}>
          <p
            className="mb-0 "
            style={{
              color: ' var(--color-on-base-content-high)'
            }}
          >
            <div className="d-flex gap-3 algn-items-center">
              <div style={{ width: 40 }}>
                <Image
                  style={{ width: '30px', borderRadius: '50%' }}
                  src={details?.avatar ?? imgUser}
                  fluid
                  onError={(event) => {
                    event.target.src = imgUser
                    event.onerror = null
                  }}
                />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: 400 }}>
                  {`${details?.nameEn ?? ''} ${details?.surnameEn ?? ''}${
                    details?.nicknameEn ? ` (${details.nicknameEn})` : ''
                  }`}
                </div>
                <div style={{ fontSize: '9px', fontWeight: 400 }}>
                  {`${details.code}` ?? '-'}
                </div>
              </div>
            </div>
          </p>
        </td>

        <td
          style={{
            ...nameCellStyle('150px'),
            maxWidth: '150px'
          }}
        >
          <p
            className="mb-0 font-small-2"
            style={{
              ...twoLineClampStyle,
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {details.licensePlate ? `${details.licensePlate}` : '-'}
          </p>
        </td>
        <td style={nameCellStyle('156px')}>
          <p
            className="mb-0 font-small-2"
            style={{
              ...twoLineClampStyle,
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {details.remark ? `${details.remark}` : '-'}
          </p>
        </td>

        <td style={centerCellStyle('120px')}>
          <p
            className="mb-0 font-small-2"
            style={{
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {details?.notifyChannelCounts?.LARK
              ? `${details.notifyChannelCounts.LARK.active} / ${details.notifyChannelCounts.LARK.total}`
              : '-'}
          </p>
        </td>

        <td style={centerCellStyle('120px')}>
          <p
            className="mb-0 font-small-2"
            style={{
              color: 'var(--color-on-base-content-high)'
            }}
          >
            {details?.notifyChannelCounts?.LINE
              ? `${details.notifyChannelCounts.LINE.active} / ${details.notifyChannelCounts.LINE.total}`
              : '-'}
          </p>
        </td>

        <td style={centerCellStyle('120px')}>
          <Button
            variant="light"
            className="text-primary rounded-2 px-2 me-2"
            style={{
              width: '40px',
              height: '32',
              marginTop: '2px',
              borderColor: 'var(--color-on-base-border-default)',
              backgroundColor: 'var(--color-base-foreground-elevated-16)'
            }}
            size="sm"
            onClick={() => onEdit?.(details?.attendanceId ?? '')}
          >
            <TbListSearch
              size={18}
              style={{
                color: 'var(--color-on-base-content-high)'
              }}
            />
          </Button>
        </td>
      </>
    )
  }

  return (
    <>
      <Row>
        <Col xs={12} className="d-flex" style={{ minWidth: 0 }}>
          <NavTitle>
            <TextNavTitle>{t('hrms_notification_header_menu')}</TextNavTitle>
          </NavTitle>
        </Col>
      </Row>
      <Col xl={12} className="mb-3">
        <CardCustom
          className="d-flex flex-column h-100"
          style={{
            minHeight: '88vh'
          }}
        >
          <Row className="p-3 g-3 flex-shrink-0">
            <Col xl={2} md={4}>
              <Controller
                name={'selectedOrg'}
                control={control}
                render={({ field: { onChange, value = null } }) => (
                  <AutocompleteCustomA
                    isClearable={false}
                    value={value}
                    options={orgRole.map((org) => ({
                      label: org.org,
                      value: org.org_id
                    }))}
                    onChange={handleChangeOrg}
                  />
                )}
              />
            </Col>
            <Col xl={4} md={6}>
              <InputSearch
                value={search}
                onChange={(e) => {
                  if (!e) {
                    clearSearch()
                  }
                  setSearch(e)
                  setPage(1) // reset page ทุกครั้งที่ search
                }}
                // onKeyDown={handleKeyDocNo}
                placeholder={t('hrms_notification_search_employee')}
              />
            </Col>

            <Col xl={6} md={2} className="text-end">
              <Button
                onClick={handleAdd}
                style={{
                  minWidth: '100px',
                  height: 40,
                  padding: '0 16px',
                  borderColor: 'var(--color-primary-border-default)',
                  backgroundColor:
                    'var(--comp-btn-color-background-secondary-normal',
                  color: 'var(--color-primary-content-default)',
                  borderRadius: 8,
                  fontSize: 14,
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }}
              >
                <HiOutlinePlus /> {t('hrms_notification_btn_add')}
              </Button>
            </Col>
          </Row>
          {/* ===== Table ===== */}

          <div
            style={{
              flex: 1,
              minHeight: 0, // ⭐ สำคัญมาก
              overflowY: 'auto',
              position: 'relative'
            }}
          >
            <GenericTable
              data={details}
              columns={columns}
              isLoading={isLoading}
              rowStartIndex={(page - 1) * limit}
              renderRow={(details, borderStyle) =>
                renderLocationRow(details, borderStyle, handleEditLocation)
              }
              visible_rows={10}
            />
          </div>

          <div
            style={{
              flexShrink: 0,
              borderTop: '1px solid var(--color-base-border-default)',
              padding: '0px 12px',
              boxShadow:
                '0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014'
            }}
          >
            <Row
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: 16
              }}
            >
              <Col xl={6} md={12}>
                <RowPerPageCustom
                  onChange={(d) => {
                    setPage(1)
                    setLimit(d)
                    getIndexNoti({
                      page: 1,
                      size: d,
                      orgId: roleId,
                      search: search || ''
                    })
                  }}
                  currentSize={limit}
                />
              </Col>
              <Col xl={6} md={12} className="d-flex justify-content-end">
                <Pagination
                  size="small"
                  current={page}
                  pageSize={limit}
                  total={totalRows}
                  showSizeChanger={false}
                  onChange={(p) => {
                    setPage(p)
                    getIndexNoti({
                      page: p,
                      size: limit,
                      orgId: roleId,
                      search: search || ''
                    })
                  }}
                />
              </Col>
            </Row>
          </div>
        </CardCustom>
      </Col>
    </>
  )
}

export default NotiCheckInPege
